import { useFormFieldsSync } from "@vestwell-frontend/hooks";
import { memo } from "react";
export var FormFieldsSyncObserver = /*#__PURE__*/ memo(function(props) {
    useFormFieldsSync(props);
    return null;
});
FormFieldsSyncObserver.displayName = 'FormFieldsSyncObserver';

//# sourceMappingURL=FormFieldsSyncObserver.js.map